
export default {
  name: 'TailwindBreakpoints',
  computed: {
    development() {
      return process.env.NODE_ENV !== 'production'
    }
  }
}
